<template>
  <div>
    <navbar-component />
    <div class="bg-container pb-4">
      <super-buyer-content-layout :texts="texts"></super-buyer-content-layout>
    </div>
    <footer-component />
    <whatsapp-component />
  </div>
</template>

<script>
export default {
  name: "SuperBuyerView",
  data() {
    return {
      //VARIABLES
      texts: "",
    };
  },
  beforeMount() {
    this.texts = FILE.superbuyer[this.selectLanguage];
  },
  computed: {
    selectLanguage: function() {
      return this.$store.state.language;
    },
  },
  watch: {
    selectLanguage: function() {
      if (this.selectLanguage) {
        this.texts = FILE.superbuyer[this.selectLanguage];
      }
    },
  },
};
</script>

<style scoped>
.bg-container {
  width: 100%;
  background: #f2f2f4 0% 0% no-repeat padding-box;
  opacity: 1;
  padding-top: 75px;
}
</style>
